import type { AsyncSelectOption } from "../../../../components/Form/AsyncSearchableSelect/AsyncSearchableSelect";
import { researcherOption, type LabelledResearcher } from "./researcherOption";

export const UNASSIGNED_OPTION: AsyncSelectOption = {
  value: null,
  label: "Unassigned",
};

export function assigneeOptions(researchers: LabelledResearcher[]): AsyncSelectOption[] {
  return researchers.map(researcherOption);
}
